/*
  JS Suche – unsichtbare Nummernliste für die Shop-Suche (seit V2-12, 20.10.2026).
  Daten: assets/js-such-index.json (gebaut mit D:\Soft\Claude\Shop-Suche\programm\such_index.py).
  Findet Jürgens Kürzel von der Rechnung (Afterbuy-Feld EAN), die Afterbuy-Produkt-ID
  (auch mit Anhang „-Anr“) und die kurze Anr. Ohne Daten oder bei Fehlern läuft die normale Suche weiter.
*/
(() => {
  if (window.JSSuche) return;

  let laden = null;

  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .trim()
      .replace(/^(art(ikel)?[\s.\-]*(nr|nummer)[\s.:#\-]*|artikel[\s:#\-]+|nr[\s.:#\-]+)/, '')
      .replace(/\s+/g, '');

  function index(url) {
    if (!laden) {
      laden = fetch(url, { credentials: 'omit' })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          if (!d) return null;
          const kuerzel = new Map();
          const pid = new Map();
          const anr = new Map();
          for (const z of d.v) {
            const eintrag = { p: d.p[z[0]], vid: z[1], kuerzel: z[2], pid: z[3], anr: z[4], variante: z[5] };
            if (z[2]) {
              const k = norm(z[2]);
              if (!kuerzel.has(k)) kuerzel.set(k, []);
              kuerzel.get(k).push(eintrag);
            }
            pid.set(String(z[3]), eintrag);
            if (z[4]) anr.set(String(z[4]), eintrag);
          }
          return { kuerzel, pid, anr, katalog: d.k || [] };
        })
        .catch(() => null);
    }
    return laden;
  }

  const adresse = (e) => `/products/${e.p[0]}?variant=${e.vid}`;

  /* Ergebnis: { sprung } = genau ein Artikel, { liste } = mehrere passende, { anr } = nur kurze Nummer */
  function finde(daten, eingabe) {
    if (!daten) return null;
    const q = norm(eingabe);
    if (!q) return null;

    let m = q.match(/^(\d{6,9})(?:[-\/](\d{1,5}))?$/);
    if (m && daten.pid.has(m[1])) return { sprung: daten.pid.get(m[1]) };

    const genau = daten.kuerzel.get(q);
    if (genau) return genau.length === 1 ? { sprung: genau[0] } : { liste: genau };

    if (/^\d{3,5}$/.test(q) && daten.anr.has(q)) return { anr: daten.anr.get(q) };

    if (q.length >= 5 && /[a-z]/.test(q) && /[-,]/.test(q)) {
      const liste = [];
      for (const [k, eintraege] of daten.kuerzel) {
        if (k.startsWith(q)) liste.push(...eintraege);
        if (liste.length > 12) break;
      }
      if (liste.length) return { liste: liste.slice(0, 12) };
    }
    return null;
  }

  /* Katalog auf Anfrage: alle Suchwörter müssen passen (Zahlen als ganze Zahl, Wörter auch ohne Endung) */
  function katalogFinde(daten, eingabe) {
    if (!daten || !daten.katalog.length) return [];
    const woerter = String(eingabe || '')
      .toLowerCase()
      .replace(/ø|Ø/g, ' ')
      .replace(/(\d)\s*mm\b/g, '$1')
      .replace(/(\d)\.(\d)/g, '$1,$2')
      .split(/[\s\/×x]+/)
      .filter((w) => w && w !== 'mm' && w !== 'ø');
    if (!woerter.length) return [];
    const pruefer = woerter.map((w) => {
      if (/^\d+(,\d+)?$/.test(w)) {
        const re = new RegExp(`(^|[^\\d,])${w}([^\\d,]|$)`);
        return (t) => re.test(t);
      }
      const stamm = w.length > 4 ? w.replace(/(en|n|e|s)$/, '') : w;
      return (t) => t.includes(stamm);
    });
    return daten.katalog.filter((k) => {
      const text = `${k[0]} ${k[1]} ${k[3]} ${k[4]} ${k[6] || ""}`.toLowerCase();
      return pruefer.every((p) => p(text));
    });
  }

  window.JSSuche = { index, finde, adresse, norm, katalogFinde };

  /*
    „Auf Anfrage“ unter Verfügbarkeit (Kategorien, seit V2-13; Darstellung wie der Shop seit V2-15).
    Häkchen kommt aus snippets/list-filter.liquid ([data-js-anfrage], ohne name → kein Shopify-Filter).
    Treffer als Karten wie auf der Seite „Ösen, Scheiben und Nieten auf Anfrage“ (snippets/js-katalog-karte.liquid,
    assets/js-katalog.css) im Raster der Produktkarten über den Shop-Artikeln.
    Zustand nur für diesen Besuch gemerkt (sessionStorage): Wer später wiederkommt, sieht wieder alle Shop-Artikel.
    Mitgefiltert: Innen-Ø (oese_innen) und Material (oese_material).
  */
  const ANFRAGE_SPEICHER = 'jsAnfrageFilter';
  const ANFRAGE_ERSTE = 10; // zwei Reihen, damit vorrätige Shop-Artikel nicht weit nach unten rutschen
  const anfrageAn = () => {
    try { return sessionStorage.getItem(ANFRAGE_SPEICHER) === 'an'; } catch (e) { return false; }
  };
  const anfrageMerken = (an) => {
    try { sessionStorage.setItem(ANFRAGE_SPEICHER, an ? 'an' : 'aus'); } catch (e) {}
  };

  function anfrageTreffer(daten, bereiche) {
    const p = new URLSearchParams(window.location.search);
    // Nur Innen-Ø der Ösen: bei Nieten ist im Katalog der Schaft-Ø hinterlegt, im Shop der Kopf-Ø (nicht vergleichbar)
    const masse = p.getAll('filter.v.m.custom.oese_innen')
      .map((w) => parseFloat(w.replace(',', '.')))
      .filter((z) => !Number.isNaN(z));
    const materialien = p.getAll('filter.v.m.custom.oese_material').map((m) => m.toLowerCase());
    return daten.katalog.filter((k) => {
      if (!bereiche.includes(k[6])) return false;
      if (masse.length && !(k[7] != null && masse.some((m) => Math.abs(m - k[7]) < 0.3))) return false;
      if (materialien.length) {
        const text = (k[8] || '').toLowerCase();
        const passt = materialien.some((m) =>
          m === 'stahl' ? /(^|[^a-zäöü])stahl/.test(text) : text.includes(m)
        );
        if (!passt) return false;
      }
      return true;
    });
  }

  /* Karte wie snippets/js-katalog-karte.liquid: Bild, Name, Art.-Nr. · Kurzzeichen, „Auf Anfrage“ an der Preisstelle */
  function anfrageKarte(k) {
    const li = document.createElement('li');
    li.className = 'jsk-karte';
    const a = document.createElement('a');
    a.className = 'jsk-karte__link';
    a.href = `/pages/katalog/${k[2]}`;
    const bild = document.createElement('span');
    bild.className = 'jsk-karte__bild';
    if (k[5]) {
      const img = document.createElement('img');
      img.src = k[5].replace(/([?&]width=)\d+/, '$1600');
      img.alt = k[1]; img.loading = 'lazy'; img.width = 600; img.height = 600;
      bild.append(img);
    }
    const titel = document.createElement('span'); titel.className = 'jsk-karte__titel'; titel.textContent = k[1];
    const nr = document.createElement('span'); nr.className = 'jsk-karte__nr';
    nr.textContent = `Art.-Nr. ${k[0]}${k[4] ? ` · ${k[4]}` : ''}`;
    const preis = document.createElement('span'); preis.className = 'jsk-karte__preis'; preis.textContent = 'Auf Anfrage';
    a.append(bild, titel, nr, preis);
    li.append(a);
    return li;
  }

  function anfrageCss(url) {
    if (!url || document.querySelector('link[data-js-katalog-css]')) return;
    const l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = url; l.dataset.jsKatalogCss = '';
    document.head.append(l);
  }

  /* Leiste oben: „Verfügbarkeit“ zeigt die Auswahl wie bei den anderen Filtern (ein Wert = Name, mehrere = Anzahl) */
  function anfrageStatus(haken, an) {
    haken.forEach((x) => {
      const panel = x.closest('details');
      const status = panel && panel.querySelector('.facets__status [ref="facetStatus"], .facets__status span');
      if (!status) return;
      const echte = [...panel.querySelectorAll('input[type="checkbox"][name]:checked')];
      const werte = echte.map((e) => e.dataset.label || e.value);
      if (an) werte.push(x.dataset.label);
      const text = werte.length > 1 ? String(werte.length) : werte[0] || '';
      if (status.textContent === text) return;
      status.textContent = text;
      status.classList.toggle('bubble', werte.length > 1);
      status.classList.toggle('facets__bubble', werte.length > 1);
      // Leiste neu aufteilen lassen (Theme klappt sonst nicht in „Mehr“ ein, weil sich nur Text geändert hat)
      const leiste = panel.closest('overflow-list');
      if (leiste) { const marke = document.createComment(''); leiste.append(marke); marke.remove(); }
    });
  }

  /* „Alles löschen“ (Leiste, Schublade) und „Löschen“ in „Verfügbarkeit“ zeigt das Theme nur bei Shopify-Filtern:
     solange „Auf Anfrage“ an ist, ebenfalls einblenden (Klassen wie das Theme: active, facets__clear--active) */
  function anfrageLoeschenZeigen(haken, an) {
    const schalten = (el, klasse) => {
      if (an && !el.classList.contains(klasse)) { el.classList.add(klasse); el.dataset.jsAnfrage = ''; }
      if (!an && 'jsAnfrage' in el.dataset) { el.classList.remove(klasse); delete el.dataset.jsAnfrage; }
    };
    document.querySelectorAll('.facets__actions .facets__clear-all').forEach((el) => schalten(el, 'active'));
    haken.forEach((x) => {
      const knopf = x.closest('details, .facets__panel, accordion-custom')?.querySelector('.facets__clear');
      if (knopf) schalten(knopf, 'facets__clear--active');
    });
  }

  /* „58 Artikel“ in der Leiste: Shop-Artikel (falls sichtbar) plus Artikel auf Anfrage */
  function anfrageZaehler(an, nurAnfrage, anzahl) {
    document.querySelectorAll('.products-count-wrapper span').forEach((el) => {
      if (!('jsShop' in el.dataset)) {
        el.dataset.jsShop = parseInt(el.textContent.replace(/\D/g, ''), 10) || 0;
        el.dataset.jsShopText = el.textContent;
      }
      const shop = Number(el.dataset.jsShop);
      el.textContent = an ? `${nurAnfrage ? anzahl : shop + anzahl} Artikel` : el.dataset.jsShopText;
    });
    // Knopf unten in der Filter-Schublade (Handy): „58 Artikel anzeigen“
    document.querySelectorAll('.facets__see-results').forEach((el) => {
      if (!('jsShop' in el.dataset)) {
        el.dataset.jsShop = parseInt(el.textContent.replace(/\D/g, ''), 10) || 0;
        el.dataset.jsShopText = el.textContent;
      }
      const shop = Number(el.dataset.jsShop);
      el.textContent = an ? `${nurAnfrage ? anzahl : shop + anzahl}\u00a0Artikel anzeigen` : el.dataset.jsShopText;
    });
  }

  let anfrageLaeuft = false;
  async function anfrageAktualisieren() {
    const haken = [...document.querySelectorAll('[data-js-anfrage]')];
    const altKasten = document.getElementById('js-anfrage-kasten');
    if (!haken.length) {
      if (altKasten) altKasten.remove();
      document.documentElement.classList.remove('js-nur-anfrage');
      return;
    }
    if (anfrageLaeuft) return;
    anfrageLaeuft = true;
    try {
      const h = haken[0];
      anfrageCss(h.dataset.css);
      const bereiche = h.dataset.bereiche.split(',').map((b) => b.trim());
      const daten = await index(h.dataset.index);
      if (!daten) return;
      const treffer = anfrageTreffer(daten, bereiche);
      const an = anfrageAn();
      haken.forEach((x) => { x.checked = an; });
      // Nur „Auf Anfrage“ angehakt (kein Lager-Filter): Shop-Artikel ausblenden
      const lager = new URLSearchParams(window.location.search).has('filter.v.availability');
      const nurAnfrage = an && !lager;
      anfrageStatus(haken, an);
      anfrageZaehler(an, nurAnfrage, treffer.length);
      anfrageLoeschenZeigen(haken, an);

      let kasten = altKasten;
      const raster = document.getElementById('ResultsList');
      if (!kasten) {
        kasten = document.createElement('div');
        kasten.id = 'js-anfrage-kasten';
        kasten.className = 'js-anfrage-treffer';
      }
      if (raster && kasten.nextElementSibling !== raster) raster.before(kasten);
      kasten.hidden = !an;
      if (an) {
        kasten.replaceChildren();
        if (treffer.length) {
          // Gleiches Raster wie die Shop-Artikel (Spalten, Abstände, Handy), sonst das Raster der Anfrage-Seite
          const ul = document.createElement('ul');
          const shopRaster = raster && raster.querySelector('.product-grid');
          if (shopRaster) {
            ul.className = `${shopRaster.className} list-unstyled`;
            ['style', 'product-grid-view'].forEach((n) => {
              if (shopRaster.hasAttribute(n)) ul.setAttribute(n, shopRaster.getAttribute(n));
            });
            // Abstände hängen am Abschnitt (--product-grid-gap-desktop/-mobile), nicht an der Liste: mitnehmen
            const stil = getComputedStyle(shopRaster);
            ['--product-grid-gap-desktop', '--product-grid-gap-mobile'].forEach((v) => {
              const wert = stil.getPropertyValue(v);
              if (wert) ul.style.setProperty(v, wert.trim());
            });
          } else {
            ul.className = 'jsk-raster';
          }
          ul.append(...treffer.slice(0, ANFRAGE_ERSTE).map(anfrageKarte));
          kasten.append(ul);
          if (treffer.length > ANFRAGE_ERSTE) {
            const mehr = document.createElement('button');
            mehr.type = 'button'; mehr.className = 'button button-secondary';
            mehr.textContent = `Alle ${treffer.length} Artikel auf Anfrage anzeigen`;
            mehr.addEventListener('click', () => { ul.replaceChildren(...treffer.map(anfrageKarte)); mehr.remove(); }, { once: true });
            kasten.append(mehr);
          }
        } else {
          const leer = document.createElement('p');
          leer.className = 'jsk-leer';
          leer.textContent = 'Keine passenden Artikel auf Anfrage. Andere Größe wählen oder Anfrage stellen.';
          kasten.append(leer);
        }
      }
      document.documentElement.classList.toggle('js-nur-anfrage', nurAnfrage);
    } finally {
      anfrageLaeuft = false;
    }
  }

  document.addEventListener('change', (ev) => {
    const x = ev.target;
    if (!(x instanceof HTMLInputElement) || !x.matches('[data-js-anfrage]')) return;
    ev.stopImmediatePropagation();
    anfrageMerken(x.checked);
    anfrageAktualisieren();
  }, true);

  // „Alles löschen“ und „Zurücksetzen“ nehmen auch „Auf Anfrage“ weg
  document.addEventListener('click', (ev) => {
    if (!(ev.target instanceof Element) || !ev.target.closest('.facets__clear-all, .facets__clear')) return;
    if (!anfrageAn()) return;
    anfrageMerken(false);
    anfrageAktualisieren();
  }, true);

  // Nach jedem Filterwechsel (Horizon ersetzt Teile der Seite) neu prüfen
  let letzteAdresse = '';
  const pruefen = () => {
    const neu = window.location.search;
    const kasten = document.getElementById('js-anfrage-kasten');
    const zaehler = document.querySelector('.products-count-wrapper span');
    const fehlt = document.querySelector('[data-js-anfrage]') && anfrageAn() &&
      (!kasten || !document.querySelector('[data-js-anfrage]:checked') || (zaehler && !('jsShop' in zaehler.dataset)));
    if (neu !== letzteAdresse || fehlt) {
      letzteAdresse = neu;
      anfrageAktualisieren();
    }
  };
  const starten = () => {
    if (!document.querySelector('[data-js-anfrage]')) return;
    anfrageAktualisieren();
    letzteAdresse = window.location.search;
    new MutationObserver(() => pruefen()).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', pruefen);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();

  /* Suchleiste: bei eindeutiger Nummer direkt zum Artikel, sonst normale Suche */
  document.addEventListener('submit', async (ev) => {
    const form = ev.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-js-suche]')) return;
    const feld = form.querySelector('input[name="q"]');
    const wert = feld && feld.value;
    const q = norm(wert);
    const sieht_aus_wie_nummer = /^\d{6,9}([-\/]\d{1,5})?$/.test(q) || (/[a-z]/.test(q) && /\d/.test(q) && q.includes('-'));
    if (!sieht_aus_wie_nummer) return;
    ev.preventDefault();
    const zeit = new Promise((r) => setTimeout(() => r(null), 1500));
    const daten = await Promise.race([index(form.dataset.jsSuche), zeit]);
    const treffer = finde(daten, wert);
    if (treffer && treffer.sprung) window.location.href = adresse(treffer.sprung);
    else form.submit();
  });
})();
